export default "<!-- <g10-transportManager-dashboardMenu></g10-transportManager-dashboardMenu> -->\r\n<view-request></view-request>";